<div class="grid md:grid-cols-2 items-center px-[4.75rem] min-h-[100vh] h-full w-full">
  <section>
    <div class="gap-2">
      <span class="text-sm md:text-base font-light">404 ERROR</span>
      <h1 class="text-3xl md:text-[2.5rem] font-bold leading-none">Page not found</h1>
    </div>
    <p class="text-lg md:text-2xl mt-10">
      Sorry, we could not find the page you’re looking for. Prehaps you’ve mistyped the URL? Be sure
      to check your spelling.
    </p>
  </section>
  <section>
    <img src="assets/imgs/page-not-found.svg" />
  </section>
</div>
